"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertAnchor = exports.AlertLink = exports.AlertButton = exports.Alert = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Button_1 = require("../../atoms/Button/Button");
const Link_1 = require("../../atoms/Link/Link");
const icons_1 = require("../../../icons/icons");
const infoBoxStyle = (type) => {
    switch (type) {
        case 'info':
            return ['bg-blue-1', icons_1.SVG_ALERT_INFO, 'text-blue-5'];
        case 'warning':
            return ['bg-yellow-1', icons_1.SVG_ALERT_EXCLAMATION, 'text-yellow-4'];
        case 'error':
            return ['bg-red-1', icons_1.SVG_ALERT_EXCLAMATION, 'text-red-4'];
        case 'success':
            return ['bg-green-1', icons_1.SVG_ALERT_TICK, 'text-green-4'];
        default:
            return ['bg-blue-1', icons_1.SVG_ALERT_INFO, 'text-blue-5'];
    }
};
const Alert = ({ type, title, body, cta, ctaPos = 'left', children, className, testing }) => {
    const [backgroundColorClass, svgIcon, iconStyle] = infoBoxStyle(type);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('mb-2 flex rounded-lg px-6 py-5', backgroundColorClass, className), "data-testid": testing && 'alert-container' },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('mr-5 flex h-5 w-5 items-center justify-center', iconStyle), "data-testid": testing && 'alert-icon' }, svgIcon),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('flex-grow lg:flex', ctaPos === 'left' ? 'flex-row' : ' flex-col gap-2') },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('flex w-full flex-grow flex-col items-start') },
                title && react_1.default.createElement("h4", { className: "block text-base font-bold leading-tight" }, title),
                body && react_1.default.createElement("p", { className: (0, classnames_1.default)(title && 'mt-2') }, body),
                children),
            cta && react_1.default.createElement("div", { className: "mt-5 lg:mt-0" }, cta))));
};
exports.Alert = Alert;
const AlertButton = ({ type, title, body, label, onClick, disabled, tracking, className }) => {
    return (react_1.default.createElement(exports.Alert, { type: type, title: title, body: body, cta: label ? (react_1.default.createElement(Button_1.Button, { appearance: "reverse", size: "xs", onClick: onClick, className: "whitespace-nowrap", disabled: disabled, tracking: tracking }, label)) : undefined, ctaPos: "left", className: className }));
};
exports.AlertButton = AlertButton;
const AlertLink = ({ type, title, body, text, to, className }) => {
    return (react_1.default.createElement(exports.Alert, { type: type, title: title, body: body, cta: text && to ? (react_1.default.createElement(Link_1.Link, { className: "font-bold uppercase", to: to }, text)) : undefined, ctaPos: "bottom", className: className }));
};
exports.AlertLink = AlertLink;
const AlertAnchor = ({ type, title, body, text, href, className }) => {
    return (react_1.default.createElement(exports.Alert, { type: type, title: title, body: body, cta: text && href ? (react_1.default.createElement(Link_1.Anchor, { className: "font-bold uppercase", href: href }, text)) : undefined, ctaPos: "bottom", className: className }));
};
exports.AlertAnchor = AlertAnchor;
